export enum QueueJobStatusEnum {
  RUNNING = 'running',
  SUCCEEDED = 'succeeded',
  FAILED = 'failed',
  STALE = 'stale',
  QUEUED = 'queued',
}
